import React from "react";
import Styled from 'styled-components';
import { PositionBoxComponentsType, PositionBoxPropsType, PositionBoxTypes } from "./types";
import Box from "..";

const computeValue = (value: number | string) => {
    if(typeof value === "number") {
        return `${value || 0}px`;
    }
    return value;
}

const ContainerDiv = Styled(Box)<PositionBoxPropsType>`
    position: ${props => props?.position || PositionBoxTypes.RELATIVE};
    top: ${props => computeValue(props?.top)};
    left: ${props => computeValue(props?.left)};
    bottom: ${props => computeValue(props?.bottom)};
    right: ${props => computeValue(props?.right)};
    z-index: ${props => props.zIndex || 1};
`;

const PositionBox: React.FC<PositionBoxPropsType> & PositionBoxComponentsType = ({ children, ...props }) => {
    return <ContainerDiv data-test-class={`sui-position`} {...props}>{children}</ContainerDiv>
}

PositionBox[PositionBoxTypes.RELATIVE] = (props) => <PositionBox position={PositionBoxTypes.RELATIVE} {...props}/>;
PositionBox[PositionBoxTypes.ABSOLUTE] = (props) => <PositionBox position={PositionBoxTypes.ABSOLUTE} {...props}/>;
PositionBox[PositionBoxTypes.FIXED] = (props) => <PositionBox position={PositionBoxTypes.FIXED} {...props}/>;
PositionBox[PositionBoxTypes.STICKY] = (props) => <PositionBox position={PositionBoxTypes.STICKY} {...props}/>;

export default PositionBox;
    